<script setup lang="ts">
import { inject, Ref, ref } from 'vue';
import { cloneDeep } from 'lodash';
import { useI18n } from 'vue-i18n';
import { getCurrentLocale } from '@/i18n';
import { useViewRuleStore } from '@/store/ViewRuleStore';
import { useToast } from 'primevue/usetoast';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import HTMLDisplay from '@/components/common/HTMLDisplay.vue';
import RuleAssignmentPriority from '@/components/admin/RuleAssignment/RuleAssignmentPriority.vue';

const dialogRef = inject('dialogRef') as Ref;
const ruleAssignment = dialogRef?.value?.options.data.ruleAssignment;
const onApply = dialogRef?.value?.options.emits.onApply;

const viewRuleStore = useViewRuleStore();
const currentLanguage = getCurrentLocale();
const { t } = useI18n({ useScope: 'global' });
const toast = useToast();

const ruleAssignmentData = ref(cloneDeep(ruleAssignment));
const isLoading = ref(false);

const handleSubmitRuleAssignment = () => {
  isLoading.value = true;
  viewRuleStore
    .updateRuleAssignment(ruleAssignmentData.value)
    .then(() => {
      toast.add({ severity: 'success', summary: '', detail: t('notification.save_successfully'), life: 3000 });
      onApply();
    })
    .catch(() => {
      toast.add({ severity: 'error', summary: '', detail: t('notification.save_error'), life: 5000 });
    })
    .finally(() => {
      isLoading.value = false;
    });
};
</script>

<template>
  <div class="manage-rule-assignment-modal">
    <div class="field grid">
      <div class="col-4">
        <p>{{ $t('rule_assignment.rule_section') }}</p>
        <div>
          <InputText disabled :modelValue="ruleAssignmentData[0]?.section" />
        </div>
      </div>
    </div>
    <div class="field grid">
      <div class="w-full">
        <p class="pl-2">{{ $t('rule_assignment.rule') }}</p>
        <div class="pl-2 pr-2">
          <div class="rule-assignment-display">
            <HTMLDisplay :frHTMLData="ruleAssignmentData[0].ruleFr" :enHTMLData="ruleAssignmentData[0]?.rule" :currentLanguage="currentLanguage" />
          </div>
        </div>
      </div>
    </div>
    <RuleAssignmentPriority v-model:ruleAssignment="ruleAssignmentData" />
    <div class="text-center mt-5">
      <Button :loading="isLoading" id="submit-button" :label="$t('common.buttons.submit')" @click="handleSubmitRuleAssignment()"></Button>
    </div>
  </div>
</template>
